export const INCIDENT_LABELS: Record<string, string> = {
  BITE_OR_AGGRESSION: 'Bite / aggression',
  PROPERTY_DAMAGE: 'Property damage',
  NOISE: 'Noise',
  WASTE_OR_SANITATION: 'Waste / sanitation',
  LEASH_OR_CONTAINMENT: 'Leash / containment',
  ANIMAL_TYPE_MISMATCH: 'Undeclared / mismatched animal',
  OTHER: 'Other',
}
